import React, { memo } from 'react';
import { Options } from '../../../Options';
import * as S from './styled';
export const CategoryOptions = memo(({ isVisible, options, initialCategory, selectedCategory, searchValue, isLoading, focusState, onSelect, onNavigateUp, onNavigateDown, }) => {
    if (!isVisible)
        return null;
    return (React.createElement(S.OptionsContainer, null,
        React.createElement(Options, { options: options, initialCategory: initialCategory, selectedCategory: selectedCategory, searchValue: searchValue, loading: isLoading, focusState: focusState, onSelect: onSelect, onNavigateUp: onNavigateUp, onNavigateDown: onNavigateDown })));
});
